/* nj-order-columns.unique.js
   Vanilla JavaScript version, scoped for multiple sections on the same page. */
(function() {
  'use strict';
  
  function initProductOffers() {
    document.querySelectorAll('.product-offers-section').forEach(function(section) {
      var sectionId = section.getAttribute('data-section-id');
      
      // Option radio click
      section.querySelectorAll('.option').forEach(function(option) {
        option.addEventListener('click', function() {
          var type = this.getAttribute('data-type');
          var id = this.getAttribute('data-id');
          var checked = section.querySelector('input[name="option-' + sectionId + '-' + id + '"]:checked');
          
          if (type === 'sub') {
            var freqDrop = section.querySelector('#freq_drop-' + sectionId + '-' + id);
            if (freqDrop) freqDrop.style.display = 'block';
            
            var optionInput = section.querySelector('input[name="option_' + sectionId + '-' + id + '"]');
            if (optionInput) optionInput.value = 'subscribe';
            
            var sellPlan = section.querySelector('#sell_plan-' + sectionId + '-' + id);
            if (sellPlan) sellPlan.value = '664207465';
          } else {
            var freqDrop = section.querySelector('#freq_drop-' + sectionId + '-' + id);
            if (freqDrop) freqDrop.style.display = 'none';
            
            var dropout = section.querySelector('#dropout_' + sectionId + '-' + id);
            if (dropout) dropout.style.display = 'none';
            
            var optionInput = section.querySelector('input[name="option_' + sectionId + '-' + id + '"]');
            if (optionInput) optionInput.value = 'add';
            
            var sellPlan = section.querySelector('#sell_plan-' + sectionId + '-' + id);
            if (sellPlan) sellPlan.value = '';
            
            var intervalSelect = section.querySelector('#interval_select-' + sectionId + '-' + id);
            if (intervalSelect) intervalSelect.value = '';
            
            var inOpt = section.querySelector('#in_opt-' + sectionId + '-' + id);
            if (inOpt) inOpt.value = '0';
          }
        });
      });
      
      // Frequency dropdown click
      section.querySelectorAll('.freq_selected').forEach(function(freqSelected) {
        freqSelected.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var id = this.getAttribute('data-rel');
          var dropout = section.querySelector('#dropout_' + sectionId + '-' + id);
          
          if (dropout && dropout.style.display !== 'block') {
            dropout.style.display = 'block';
          }
          
          var sellPlan = section.querySelector('#sell_plan-' + sectionId + '-' + id);
          if (sellPlan) sellPlan.value = this.getAttribute('data-id');
          
          var inOpt = section.querySelector('#in_opt-' + sectionId + '-' + id);
          if (inOpt) inOpt.value = '1';
        });
      });
      
      // Frequency option click
      section.querySelectorAll('.freq_opt').forEach(function(freqOpt) {
        freqOpt.addEventListener('click', function(e) {
          e.stopPropagation();
          
          var loop = this.getAttribute('data-loop');
          var rel = this.getAttribute('data-rel');
          var nid = this.getAttribute('data-id');
          var labelEl = this.querySelector('b');
          var label = labelEl ? labelEl.innerHTML : '';
          
          var intervalSelect = section.querySelector('#interval_select-' + sectionId + '-' + loop);
          if (intervalSelect) intervalSelect.value = rel;
          
          var sellPlan = section.querySelector('#sell_plan-' + sectionId + '-' + loop);
          if (sellPlan) sellPlan.value = nid;
          
          var bLabel = section.querySelector('.b-' + loop);
          if (bLabel) bLabel.innerHTML = label;
          
          // Update dropdown label: replace 'Select Frequency' with 'Every X days'
          var freqSelected = section.querySelector('#freq_' + sectionId + '-' + loop);
          if (freqSelected) {
            var oldB = freqSelected.querySelector('b');
            if (oldB) oldB.remove();
            
            // Replace text node containing 'Select Frequency'
            Array.from(freqSelected.childNodes).forEach(function(node) {
              if (node.nodeType === 3 && node.textContent.match(/Select Frequency/)) {
                node.textContent = 'Every ' + label + ' ';
              }
            });
          }
          
          var dropout = section.querySelector('#dropout_' + sectionId + '-' + loop);
          if (dropout) dropout.style.display = 'none';
        });
      });
      
      // Checkout button click
      section.querySelectorAll('.continue-button').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.getAttribute('data-id');
          
          var productId = section.querySelector('#product_idd-' + sectionId + '-' + id);
          var quantity = section.querySelector('#in_quan-' + sectionId + '-' + id);
          var sellingPlan = section.querySelector('#sell_plan-' + sectionId + '-' + id);
          var subsType = section.querySelector('#in_opt-' + sectionId + '-' + id);
          var subsInterval = section.querySelector('#interval_select-' + sectionId + '-' + id);
          
          var data = {
            id: productId ? productId.value : '',
            quantity: quantity ? quantity.value : '1',
            selling_plan: sellingPlan ? sellingPlan.value : '',
            subs_type: subsType ? subsType.value : '',
            subs_interval: subsInterval ? subsInterval.value : ''
          };
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          })
          .then(function(res) { return res.json(); })
          .then(function() { window.location.href = '/cart'; })
          .catch(function(err) { console.error('Error:', err); });
        });
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductOffers);
  } else {
    initProductOffers();
  }
})();
